export default "assets/images/icons/clock-292666a8.svg";